export function searchQueryBuilder(queryMap: any[]) {
  return queryMap
    .filter(queryDef => typeof queryDef[1] !== 'undefined')
    .map(queryDef => {
      return `&${queryDef[0]}=${queryDef[1]}`
    }).join('')
}
